import axios from 'axios'

export default {
  namespaced: true,

  state: {
    annoImposta: [],
    tipoIstanza: [],
    tipoOrigineSoggetto: [],
    unitaImmobiliare: [],
    tipoComponente: [],
    tipoImmobile: [
      { value: 'F', text: 'F - fabbricati' },
      { value: 'AF', text: 'AF - aree fabbricabili' },
      { value: 'T', text: 'T - terreni agricoli' }
    ]
  },

  mutations: {
    setAnnoImpostaOptions (state, value) {
      state.annoImposta = value || []
    },
    setTipoIstanzaOptions (state, value) {
      state.tipoIstanza = value || []
    },
    setTipoOrigineSoggettoOptions (state, value) {
      state.tipoOrigineSoggetto = value || []
    },
    setUnitaImmobiliareOptions (state, value) {
      state.unitaImmobiliare = value || []
    },
    setTipoComponenteOptions (state, value) {
      state.tipoComponente = value || []
    }
  },

  actions: {

    async loadAnnoImpostaOptions ({ state, commit }) {
      try {
        if (!state.annoImposta.length) {
          let rs = await axios.get('/api/options/anno-imposta')
          commit('setAnnoImpostaOptions', rs.data)
        }
      } catch (err) {
        throw err
      }
    },

    async loadTipoIstanzaOptions ({ state, commit }) {
      try {
        // console.log('loadTipoIstanzaOptions state', state)
        if (!state.tipoIstanza.length) {
          let rs = await axios.get('/api/options/tipo-istanza')
          commit('setTipoIstanzaOptions', rs.data)
        }
      } catch (err) {
        throw err
      }
    },

    async loadTipoOrigineSoggettoOptions ({ state, commit }) {
      try {
        // console.log('loadTipoIstanzaOptions state', state)
        if (!state.tipoOrigineSoggetto.length) {
          let rs = await axios.get('/api/options/tipo-origine-soggetto')
          commit('setTipoOrigineSoggettoOptions', rs.data)
        }
      } catch (err) {
        throw err
      }
    },

    async loadUnitaImmobiliareOptions ({ commit }) {
      try {
        let rs = await axios.get('/api/options/unita-immobiliare')
        commit('setUnitaImmobiliareOptions', rs.data)
      } catch (err) {
        throw err
      }
    },

    async loadTipoComponenteOptions ({ state, commit }) {
      try {
        if (!state.tipoComponente.length) {
          let rs = await axios.get('/api/options/tipo-componente')
          commit('setTipoComponenteOptions', rs.data)
        }
      } catch (err) {
        throw err
      }
    }
  }
}
